import React, { useState, useEffect } from 'react';
import RangeSlider from 'react-bootstrap-range-slider';

const SliderInput = (props) => {
  const {
      label="",
      initialValue=0,
      onUpdateValue
  } = props

  const [ value, setValue ] = useState(0); 

  useEffect(() => {
    if (initialValue!==0){
      setValue(initialValue)
    }
  }, []) 

  const updateValue = (event) => {
    setValue(event.target.value);
    if(!onUpdateValue || typeof(onUpdateValue) !== 'function') return;
    onUpdateValue(event.target.value)
  }

  return (
    <div className='mb-40'>
      <p className='body-copy mb-8'>{label}</p>
      <RangeSlider
        tooltip='on'
        tooltipPlacement='top'
        value={value}
        onChange={updateValue}
        tooltipStyle={{zIndex: -1}}
        {...props}
      />
    </div>
    
  )
}

export default SliderInput;

